import { useEffect } from "react";

const useBreadcrumbUpdates = breadcrumbs => {
  useEffect(() => {
    window.asos.siteChrome.setBreadcrumbs(breadcrumbs);
  }, [breadcrumbs]);
};

export default useBreadcrumbUpdates;
